














































import { Component, Prop, Vue } from "vue-property-decorator";
import ItemData from "../model/ItemData";
@Component
export default class item extends Vue {
  @Prop() item!: ItemData;
  editData(item: ItemData) {
    let newitem = JSON.parse(JSON.stringify(this.item));
    this.$store.commit("setTransItem", newitem);
  }
  archive(item: ItemData) {
    if (item.archive) {
      item.archive = false;
    } else {
      item.archive = true;
    }

    this.$store.state.actionHelper.editData(item);
  }
  remove(): void {
    if (!confirm(`确认要删除<${this.item.title}>的笔记吗？`)) return;
    this.$store.state.actionHelper.remove(this.item.id);
  }
}
